import React from 'react';
import { Box, Flex, Text, VStack, Divider, Icon, Center, Skeleton, SkeletonCircle, SkeletonText } from '@chakra-ui/react';
import { InfoIcon, WarningIcon, CheckCircleIcon, TimeIcon } from '@chakra-ui/icons';
import { formatDateTime } from '../utils/dateUtils';

const NotificationList = ({ notifications, isLoading, onItemClick, limit, emptyMessage = "目前沒有通知" }) => {

    const displayNotifications = limit ? notifications.slice(0, limit) : notifications;

    // Helper to get icon based on type
    const getIcon = (type) => {
        switch (type) {
            case 'warning': return <Icon as={WarningIcon} color="orange.500" />;
            case 'pickup_request': return <Icon as={TimeIcon} color="blue.500" />;
            case 'attendance_alert': return <Icon as={WarningIcon} color="red.500" />;
            case 'parent_departed': return <Icon as={TimeIcon} color="green.500" />;
            case 'eta_10min': return <Icon as={TimeIcon} color="orange.400" />;
            case 'eta_5min': return <Icon as={TimeIcon} color="red.400" />;
            case 'eta_arrived': return <Icon as={CheckCircleIcon} color="red.500" />;
            case 'pickup_completed': return <Icon as={CheckCircleIcon} color="green.500" />;
            default: return <Icon as={InfoIcon} color="gray.500" />;
        }
    };

    if (isLoading && notifications.length === 0) {
        return (
            <VStack align="stretch" spacing={0} divider={<Divider />}>
                {[1, 2, 3].map((i) => (
                    <Box key={i} p={3}>
                        <Flex align="start">
                            <SkeletonCircle size="6" mr={3} />
                            <Box flex="1">
                                <SkeletonText noOfLines={2} spacing="2" skeletonHeight="2" />
                            </Box>
                        </Flex>
                    </Box>
                ))}
            </VStack>
        );
    }

    if (notifications.length === 0) {
        return (
            <Flex p={8} justify="center" align="center" direction="column" color="gray.500">
                <InfoIcon fontSize="2xl" mb={2} />
                <Text fontSize="sm">{emptyMessage}</Text>
            </Flex>
        );
    }

    return (
        <VStack align="stretch" spacing={0} divider={<Divider />}>
            {displayNotifications.map((n) => (
                <Box
                    key={n.id}
                    p={3}
                    bg={n.is_read ? 'white' : 'blue.50'}
                    _hover={{ bg: 'gray.50' }}
                    cursor="pointer"
                    onClick={() => onItemClick && onItemClick(n)}
                    transition="background 0.2s"
                >
                    <Flex align="start">
                        <Box pt={1} mr={3}>
                            {getIcon(n.type)}
                        </Box>
                        <Box flex="1">
                            <Text fontSize="sm" fontWeight={!n.is_read ? "bold" : "normal"} noOfLines={1} mb={0.5}>
                                {n.title}
                            </Text>
                            <Text fontSize="xs" color="gray.600" noOfLines={2}>
                                {n.message}
                            </Text>
                            <Text fontSize="10px" color="gray.400" mt={1}>
                                {formatDateTime(n.created_at)}
                            </Text>
                        </Box>
                        {!n.is_read && (
                            <Box w="8px" h="8px" borderRadius="full" bg="red.500" mt={2} ml={2} />
                        )}
                    </Flex>
                </Box>
            ))}
        </VStack>
    );
};

export default NotificationList;
